import React from 'react';
import {SimpleForm, Toolbar, SaveButton, Button, useNotify, useRefresh } from 'react-admin';
import IconCancel from "@material-ui/icons/Cancel";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";

import { deleteShopImage } from "../../Model/Shop";


const ShopImageDelete = props =>{
    const notify = useNotify()
    const refresh = useRefresh()
    return (<ShopImageDeleteForm {...props} onSave={()=>{ refresh() }} onMessage={(msg)=>{  notify(msg,'warning')  }} />)
}

class ShopImageDeleteForm extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            saving : false,
            photos: this.props.photos
        }
        this.handleSubmit = this.handleFormSubmit.bind(this)
    }
  
    componentWillReceiveProps(nextProps){
        this.setState({
            photos: nextProps.photos
        })
    }

    handleFormSubmit(values, redirect){
       // alert('ffff'); return false;
        const { saving, photos } = this.state
        const { onMessage, onSave, onClose, record } = this.props
        if(saving) return;
        this.setState({saving:true})
        
        deleteShopImage(record.id, photos.key, (res)=>{
            onSave()            
            onClose()
        },(res)=>{
            onMessage(res.message)
            this.setState({saving:false})
        })
    };

    render(){
        const { saving, photos } = this.state
        const { onClose, record } = this.props 
        
        if(!photos)return null;

        return (
            <Dialog fullWidth open={true} onClose={()=>{ onClose(); }}>
                <DialogTitle>Delete Shop Image</DialogTitle>
                <SimpleForm basePath="" resource="shop" record={record} save={this.handleFormSubmit} saving={saving} toolbar={<FormToolbar onCancel={()=>{ onClose(); }}/>} redirect={false}>
                    <p style={{padding:0, margin:0, paddingBottom:30}}>Are you sure!. Do you wnat to delete this imagessssssss.</p>
                </SimpleForm>
            </Dialog>
        )
    }
}
  
  
const FormToolbar = props => (
  <Toolbar {...props} >
      <SaveButton label="Delete" alwaysEnable redirect={null} submitOnEnter={false} />
      {!props.saving && <Button label="ra.action.cancel" onClick={props.onCancel}>
          <IconCancel />
      </Button>}
  </Toolbar>
)


export default ShopImageDelete